import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FieldUpdateHandlerParam } from 'shared/form';
import { AccessFunctionFieldUpdateCallback, AccessFunctionFormSection } from 'data/accessFunction/accessFunction.types';
import {
  openDeliveryFunctionNetworkInterfaceCreatePopup,
} from 'data/deliveryFunctionNetworkInterface/deliveryFunctionNetworkInterface.actions';
import {
  getDeliveryFunctionNetworkInterfaceCreatedId,
} from 'data/deliveryFunctionNetworkInterface/deliveryFunctionNetworkInterface.selectors';
import {
  DeliveryFunctionNetworkInterface,
} from 'data/deliveryFunctionNetworkInterface/deliveryFunctionNetworkInterface.types';

// eslint-disable-next-line import/prefer-default-export
export function useDialedDigitExtractionServerFieldCreateNewNetworkInterface(
  handleFieldUpdate: AccessFunctionFieldUpdateCallback,
): [AccessFunctionFieldUpdateCallback] {
  const idCreated = useSelector(getDeliveryFunctionNetworkInterfaceCreatedId);
  const dispatch = useDispatch();
  const paramRef = useRef<FieldUpdateHandlerParam>();
  const formSectionRef = useRef<AccessFunctionFormSection>();
  const interfaceIdRef = useRef<string | number>();

  useEffect(() => {
    if (idCreated == null || paramRef.current == null || formSectionRef.current == null) {
      return;
    }

    const param = paramRef.current;
    if (param == null) {
      return;
    }

    paramRef.current = undefined;

    param.value = idCreated;
    // The value label may have been changed in the create dialog, so removing it to avoid confusion
    param.valueLabel = null;

    handleFieldUpdate(param, formSectionRef.current, interfaceIdRef.current);

  }, [idCreated]); // eslint-disable-line react-hooks/exhaustive-deps
  const handleFieldCreateNew: AccessFunctionFieldUpdateCallback = (param, formSection, interfaceId) => {

    if (formSection !== 'provisioningInterfaces' && formSection !== 'dataInterfaces' && formSection !== 'contentInterfaces' && formSection !== 'diameter') {
      return;
    }

    const netInterface: DeliveryFunctionNetworkInterface = {
      id: '',
      niid: '',
      interface: param.valueLabel,
    }

    dispatch(openDeliveryFunctionNetworkInterfaceCreatePopup(netInterface));

    paramRef.current = param;
    formSectionRef.current = formSection;
    interfaceIdRef.current = interfaceId;
  };

  return [handleFieldCreateNew];
}
